import { Validators } from '@angular/forms';

export class RateModel {
  channel = {
    value: 'third-party', // these are the defaults
    validation: Validators.compose([])
  };
  brokeragePaymentType = {
    value: 'paid-by-funder', // these are the defaults
    validation: Validators.compose([])
  };
  year = {
    value: null,
    validation: Validators.compose([])
  };
  make = {
    value: null,
    validation: Validators.compose([])
  };
  model = {
    value: null,
    validation: Validators.compose([])
  };
  odometerReading = {
    value: 0,
    validation: Validators.compose([])
  };
  depositAmount = {
    value: 0,
    validation: Validators.compose([])
  };
  totalLoanAmount = {
    value: 0,
    validation: Validators.compose([])
  };
  capitalisedPurposes = {
    value: 0,
    validation: Validators.compose([])
  };
  isHomeowner = {
    value: false,
    validation: Validators.compose([])
  };
  brokerage = {
    value: 0,
    validation: Validators.compose([])
  };
  primaryPurpose = {
    value: null,
    validation: Validators.compose([])
  };
  applicationFee = {
    value: 400,
    validation: Validators.compose([])
  };
  originationFee = {
    value: 0,
    validation: Validators.compose([])
  };
  brokerageIncludesGST = {
    value: true,
    validation: Validators.compose([])
  };
  month = {
    value: null,
    validation: Validators.compose([])
  };
  engineCapacity = {
    value: null,
    validation: Validators.compose([])
  };
  baseRate = {
    value: null,
    validation: Validators.compose([])
  };
  termInYears = {
    value: null,
    validation: Validators.compose([])
  };
  fixedTermYrs = {
    value: null,
    validation: Validators.compose([])
  };
  fuelName = {
    value: null,
    validation: Validators.compose([])
  };
  transmissionType = {
    value: null,
    validation: Validators.compose([])
  };
  variantName = {
    value: null,
    validation: Validators.compose([])
  };
  odometer = {
    value: null,
    validation: Validators.compose([])
  };
  balloonAmount = {
    value: null,
    validation: Validators.compose([])
  };
  interestType = {
    value: null,
    validation: Validators.compose([])
  };
  output = {
    value: null,
    validation: Validators.compose([])
  };
  isDiscountEligible = {
    value: null,
    validation: Validators.compose([])
  };
}
